import { tv } from 'tailwind-variants';

export const chatStyle = tv({
  slots: {
    container: `
      relative
      h-full
    `,
    header: `
      absolute
      inset-x-0
      top-0
      bg-[linear-gradient(to_bottom,_white_0%,_white_75%,_transparent_100%)]
    `,
    buttonReset: `
    `,
    body: `
      m-auto
      flex
      h-[calc(100%-24px)]
      w-[calc(100%-32px)]
      flex-col
    `,
    form: `
    `,
    messageUser: `
      prose
      prose-neutral
      ml-auto
      max-w-sm
      rounded-3xl
      bg-zinc-100
      p-4
      `,
    messageBot: `
      prose
      prose-neutral
      [&>p:last-child]:mb-0
      [&>p]:mb-4
      `,
    feed: `
        overflow-y-auto
        p-4
        pb-8
    `,
    textArea: `
      px-4
      pb-4
    `,
  },
  variants: {
    hasMessages: {
      true: {
        form: `
          absolute
          inset-x-4
          bottom-4
        `,
        feed: `
          mb-24
          pb-12
          pt-24
        `,
      },
      false: {
        body: `
          mt-[20vh]
        `,
        buttonReset: `
          hidden
        `,
      },
    },
  },
});
